<div class="sidebar-control-container">
  <div class="sidebar-control-title br-pb-1 br-mb-2 br-fw-bold br-text-secondary">
    {{ feature.name }}
    <span class="title-actions br-float-end">
      <button type="button" class="title-action-btn" (click)="toggleVisibility()"
              [matTooltip]="feature.enabled ? 'Hide layer' : 'Show layer'" aria-label="Toggle layer visibility">
        <br-icon class="layer-eye">{{ feature.enabled ? 'visibility' : 'visibility_off' }}</br-icon>
      </button>
    </span>
  </div>

  <hr class="br-my-0 br-border-top br-border-secondary br-border-1 br-w-full">

  <!-- Every registered layer needs a case here. The default is the backstop: a
       layer added without one used to render this panel as a bare title bar,
       which reads as a broken page rather than as missing controls. -->
  <ng-container [ngSwitch]="feature.key">
    <app-prospect-control *ngSwitchCase="'prospect'"></app-prospect-control>
    <app-territory-control *ngSwitchCase="'territories'"></app-territory-control>
    <app-sales-route-control *ngSwitchCase="'sales-route'"></app-sales-route-control>
    <p *ngSwitchDefault class="br-text-muted br-small br-mt-2 br-mb-0">
      This layer has no settings. Use the eye above to show or hide it.
    </p>
  </ng-container>
</div>
